import { KalgudiError } from './kalgudi-error';

/**
 * Error class for non implemented methods.
 */
export class NotImplementedError extends KalgudiError { }
